






export const textToHtml = (value: unknown): string => {
  if (value === null || value === undefined) return "";
  const text = String(value);
  if (!text.trim()) return "";

  if (/<[a-z][\s\S]*>/i.test(text)) return text;

  const escapeHtml = (s: string) =>
    s
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");

  const paragraphs = text
    .split(/\n{2,}/)
    .map((block) => block.trim())
    .filter(Boolean)
    .map((block) => `<p>${escapeHtml(block).replace(/\n/g, "<br/>")}</p>`);

  return paragraphs.length > 0 ? paragraphs.join("") : `<p>${escapeHtml(text.trim())}</p>`;
};

// Promo dates are edited in the UI as epoch millis (number), but the backend
// (matching the mobile app's `.toUtc().toIso8601String()`) expects ISO 8601
// date-time strings — sending a raw number gets silently dropped/nulled out.
export const msToIso = (val: number | string | null | undefined): string | null => {
  if (val === null || val === undefined || val === "") return null;
  const d = new Date(val);
  return Number.isNaN(d.getTime()) ? null : d.toISOString();
};

// The backend echoes promoStartDate/promoEndDate back in different shapes
// depending on the endpoint: a full ISO-8601 string, epoch millis, or (as
// seen from the SKU promo endpoint) a Jackson-serialized java.time.Instant
// written as a decimal number of SECONDS with a fractional-nanosecond part,
// e.g. 1792606560.000000000. Since the rest of the UI (InventoryStep's date
// inputs, msToIso above) always works with promo dates as epoch millis, we
// normalize whatever the server sends into millis right when a product is
// loaded, so both display and re-submission work no matter which shape came
// back.
export const promoDateToMs = (val: number | string | null | undefined): number | null => {
  if (val === null || val === undefined || val === "") return null;

  const isNumeric = typeof val === "number" || /^-?\d+(\.\d+)?$/.test(val.trim());
  if (isNumeric) {
    const num = typeof val === "number" ? val : Number(val);
    if (Number.isNaN(num)) return null;
    // Millis for any real-world date are > ~1e12 (year 2001+); a seconds
    // value won't reach 1e12 until the year 33658, so this safely tells the
    // two apart and converts seconds -> millis when needed.
    return Math.round(Math.abs(num) < 1e12 ? num * 1000 : num);
  }

  const d = new Date(val);
  return Number.isNaN(d.getTime()) ? null : d.getTime();
};

export const toPlainText = (value: unknown): string => {
  if (value === null || value === undefined) return "";
  let text = String(value).trim();
  if (!text) return "";

  if (text.startsWith("[") || text.startsWith("{")) {
    try {
      const parsed = JSON.parse(text);
      const ops = Array.isArray(parsed) ? parsed : parsed?.ops;
      if (Array.isArray(ops)) {
        text = ops
          .map((op: any) => (typeof op?.insert === "string" ? op.insert : ""))
          .join("");
      }
    } catch {}
  }

  if (/<[a-z][\s\S]*>/i.test(text)) {
    const div = document.createElement("div");
    div.innerHTML = text;
    text = div.textContent || div.innerText || "";
  }

  return text.trim();
};
